import { render, staticRenderFns } from "./goodsWarp.vue?vue&type=template&id=764bf9e9&scoped=true"
import script from "./goodsWarp.vue?vue&type=script&lang=js"
export * from "./goodsWarp.vue?vue&type=script&lang=js"
import style0 from "./goodsWarp.vue?vue&type=style&index=0&id=764bf9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bf9e9",
  null
  
)

export default component.exports